import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse,} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {AuthService} from '../services/auth.service';
import {SharedDataService} from '../services/shared-data.service';
import {UtilService} from '../services/util.service';
import {finalize, tap} from 'rxjs/operators';
import {MatSnackBar} from '@angular/material';


@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private authService: AuthService,
    private utilService: UtilService,
    private sharedDataService: SharedDataService,
    private snackBar: MatSnackBar,
  ) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.utilService.requestsInProgress++;

    const copiedReq = req.clone({withCredentials: true});

    return next.handle(copiedReq).pipe(
      tap(
        (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            if (event.body.status === -1) {
              try {
                const errorMessage = event.body.responseErrors.map(
                  (value: any) => value.message + ' '
                );
                this.snackBar.open(errorMessage, 'Dismiss');
              } catch (error) {
                console.error(error);
              }
            }
          }
        },
        (err: any) => {
          if (err instanceof HttpErrorResponse) {
            if (err.status === 401) {
              this.authService.logout();
              this.sharedDataService.businessPremise = null;
              if (this.router.url !== '/sessions/login') {
                this.router.navigate(['/sessions/login']);
              }
              console.error('error: 401');
            } else {
              return err;
            }
          }
        }
      ),
      finalize(() => {
        this.utilService.requestsInProgress--;
      })
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/interceptor/auth.interceptor.ts